<div class="fxFlex" [class]="alertClass">
  <ng-content></ng-content>
</div>
